import React, { useState, useEffect } from 'react';
import URLManager from '../funcionalidadeNavbar/URLManager';
import { useNavigate } from 'react-router-dom';
import TextField from '@mui/material/TextField';
import Autocomplete from '@mui/material/Autocomplete';

const ConsultaSaldoEstoque = () => {
  const [materiasPrimas, setMateriasPrimas] = useState([]);
  const [materiaPrimaId, setMateriaPrimaId] = useState('');
  const [inputValue, setInputValue] = useState('');
  const [saldo, setSaldo] = useState(null);
  const [mensagem, setMensagem] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    // Carregar matérias-primas da API
    const fetchMateriasPrimas = async () => {
      try {
        setLoading(true);
        const response = await fetch(`${URLManager.getBaseURL()}/materiaPrima/listar`, {
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            Authorization: `Bearer ${sessionStorage.getItem('usuarioToken')}`
          }
        });
        if (!response.ok) throw new Error('Erro ao buscar matérias-primas');
        const data = await response.json();
        setMateriasPrimas(data);
      } catch (error) {
        setMensagem(error.message);
      } finally {
        setLoading(false);
      }
    };
    fetchMateriasPrimas();
  }, []);

  const consultarSaldo = async () => {
    if (!materiaPrimaId) {
      setMensagem('Selecione a matéria-prima.');
      setSaldo(null);
      return;
    }
    setMensagem('');
    setSaldo(null);
    setLoading(true);
    try {
      const url = `${URLManager.getBaseURL()}/estoque/saldo/${materiaPrimaId}`;
      const response = await fetch(url, {
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          Authorization: `Bearer ${sessionStorage.getItem('usuarioToken')}`
        }
      });
      const result = await response.text();
      if (response.ok) {
        setSaldo(result);
      } else {
        setMensagem(result || 'Erro ao consultar saldo.');
      }
    } catch (error) {
      setMensagem('Erro de conexão com o servidor.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#f4f6fa' }}>
      <div style={{ background: '#fff', borderRadius: 12, boxShadow: '0 4px 24px rgba(0,0,0,0.10)', padding: 32, minWidth: 350, maxWidth: 400 }}>
        <h2 style={{ textAlign: 'center', marginBottom: 24, color: '#2d3a4b' }}>Consulta de Saldo de Estoque</h2>
        <div style={{ marginBottom: 18 }}>
          <label style={{ fontWeight: 500, color: '#2d3a4b' }}>Matéria-prima:</label><br />
          <Autocomplete
            options={materiasPrimas}
            getOptionLabel={option => option && (option.descricao || option.nome) ? `${option.descricao || option.nome} ${option.saldoEstoque !== undefined ? `(Saldo: ${option.saldoEstoque})` : ''}` : ''}
            filterOptions={(options, state) =>
              options.filter(option =>
                (option.descricao || option.nome || '').toLowerCase().includes(state.inputValue.toLowerCase())
              )
            }
            value={materiasPrimas.find(mp => mp.id === materiaPrimaId) || null}
            onChange={(event, newValue) => {
              setMateriaPrimaId(newValue ? newValue.id : '');
            }}
            inputValue={inputValue}
            onInputChange={(event, newInputValue) => {
              setInputValue(newInputValue);
            }}
            renderInput={(params) => (
              <TextField {...params} label="Digite para buscar..." variant="outlined" size="small" autoFocus />
            )}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            noOptionsText="Nenhuma matéria-prima encontrada"
            sx={{ width: '100%', marginTop: 1 }}
            autoHighlight
            openOnFocus
            clearOnBlur={false}
          />
        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 18 }}>
          <button
            onClick={consultarSaldo}
            disabled={loading}
            style={{
              width: '100%',
              background: '#1976d2',
              color: '#fff',
              border: 'none',
              borderRadius: 6,
              padding: '10px 0',
              fontWeight: 600,
              cursor: loading ? 'not-allowed' : 'pointer',
              marginRight: 0
            }}
          >
            {loading ? 'Consultando...' : 'Consultar Saldo'}
          </button>
        </div>
        <button
          onClick={() => navigate(-1)}
          style={{
            width: '100%',
            background: '#607d8b',
            color: '#fff',
            border: 'none',
            borderRadius: 6,
            padding: '10px 0',
            fontWeight: 600,
            cursor: 'pointer',
            marginBottom: 10
          }}
        >
          Voltar
        </button>
        {saldo !== null && (
          <div style={{
            marginTop: 10,
            color: '#388e3c',
            background: '#e8f5e9',
            borderRadius: 6,
            padding: 10,
            textAlign: 'center',
            fontWeight: 500
          }}>
            Saldo atual: <strong>{saldo}</strong>
          </div>
        )}
        {mensagem && (
          <div style={{
            marginTop: 10,
            color: '#d32f2f',
            background: '#ffebee',
            borderRadius: 6,
            padding: 10,
            textAlign: 'center',
            fontWeight: 500
          }}>
            {mensagem}
          </div>
        )}
      </div>
    </div>
  );
};

export default ConsultaSaldoEstoque;
